import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type ContainerTypeItemData = {};

export const initialContainerTypePageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
